import Layout from "./Layout";
import React, { useState } from "react";
import { sendContactInquiry } from "../services/api";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Full name is required";
    }

    if (!form.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!form.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const data = await sendContactInquiry(form);

      alert(data.message || "Inquiry sent successfully!");

      setForm({
        name: "",
        mobile: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Inquiry error:", error);
      alert("Unable to send inquiry. Please try again.");
    }

    // Call your API here
  };

  return (
    <>
      <Layout>
        {/* Section 1 */}
        <section className="max-w-6xl mx-auto px-6 py-12 text-black">
          <div>
            <h2 className="text-3xl font-serif text-light_primary mb-2">
              Our Store
            </h2>
            <p>
              Ratnakar atelier, shop no 6, jodhpur gam road, ramdev nagar,
              Satellite, Ahmedabad, Gujarat 380015
            </p>

            <p className="flex flex-col sm:flex-row sm:items-center">
              <span className="font-medium mr-2">Phone:</span>

              <span className="flex flex-col sm:flex-row sm:items-center sm:gap-4 mt-1 sm:mt-0">
                <a
                  href="tel:+919825081632"
                  className="text-primary hover:underline"
                >
                  (+91) 9825081632
                </a>

                <a
                  href="tel:+919227071152"
                  className="text-primary hover:underline"
                >
                  (+91) 9227071152
                </a>

                <a
                  href="tel:+917935565758"
                  className="text-primary hover:underline"
                >
                  079 35565758
                </a>
              </span>
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-serif text-light_primary mb-2 mt-3">
              Shop Timings
            </h2>
            <div className="flex flex-col gap-1">
              <div className="flex">
                <span className="w-18 font-medium mr-1">Mon to Sat : </span>
                <span> 10:00 AM - 8:30 PM</span>
              </div>
              <div className="flex">
                <span className="w-12 font-medium">Sun :</span>{" "}
                <span>10:00 AM - 3:00 PM</span>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2 */}
        <section className="max-w-6xl mx-auto px-6 pb-12 grid lg:grid-cols-2 gap-10">
          <div className="md:flex-1">
            <iframe
              title="Store Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.1287425717787!2d72.5130087738657!3d23.019044716462606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b7d28f73cb3%3A0x7f1a31b92e348f3!2sLegacy%20Decor!5e0!3m2!1sen!2sin!4v1758555085224!5m2!1sen!2sin"
              width="100%"
              height="400"
              className="rounded-lg shadow-lg"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl font-serif text-light_primary mb-6">
              Send an Inquiry
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4 text-black">
              <input
                type="text"
                placeholder="Full Name"
                className={`w-full rounded-lg p-3 border ${
                  errors.name ? "border-red-500" : "border-gray-300"
                }`}
                name="name"
                value={form.name}
                onChange={handleChange}
              />
              {errors.name && (
                <p className="text-red-500 text-sm">{errors.name}</p>
              )}

              <input
                type="tel"
                name="mobile"
                value={form.mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                  handleChange({
                    target: {
                      name: "mobile",
                      value,
                    },
                  });
                }}
                placeholder="Mobile Number"
                className={`w-full rounded-lg p-3 border ${
                  errors.mobile ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.mobile && (
                <p className="text-red-500 text-sm">{errors.mobile}</p>
              )}

              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                className={`w-full rounded-lg p-3 border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.email && (
                <p className="text-red-500 text-sm">{errors.email}</p>
              )}

              <textarea
                rows={5}
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Your Message"
                className={`w-full rounded-lg p-3 resize-none border ${
                  errors.message ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.message && (
                <p className="text-red-500 text-sm">{errors.message}</p>
              )}

              <button
                type="submit"
                className="w-full bg-primary text-white py-3 rounded-lg hover:bg-hover_primary transition"
              >
                Send Inquiry
              </button>
            </form>
          </div>
        </section>
      </Layout>
    </>
  );
}
